import {Image} from './image';
import {Ad} from './ad';
import {ProductRatings} from './product-ratings';

export class Option {
  id: number;
  groupId: number;
  sceneId: number;
  internalName: string;

  tileCaptionLineOne: string;
  tileCaptionLineTwo: string;
  thumbCaptionLineOne: string;
  thumbCaptionLineTwo: string;
  thumbCaptionLineThree: string;
  description: string;
  images: Image[] = [];
  ads: Ad[] = [];
  productRatings: ProductRatings;
  // productReviews: ProductReviews;
  wishlisted = false;

  static fromJSON(json: OptionJSON): Option {
    const option = Object.assign(Object.create(Option.prototype), json, {
      images: JSON.parse(json.images),
      ads: JSON.parse(json.ads)
    });

    option.images = [];
    const imageArray = JSON.parse(json.images);
    for (const img of imageArray) {
      option.images.push(Image.fromJSON(img));
    }

    option.ads = [];
    const adsArray = JSON.parse(json.ads);
    for (const ad of adsArray) {
      option.ads.push(Ad.fromJSON(ad));
    }

    return option;
  }

  toJSON(): OptionJSON {
    return Object.assign({}, this, {
      images: JSON.stringify(this.images),
      ads: JSON.stringify(this.ads)
    });
  }

  constructor(public data: any, ogId: number, sId: number) {
    const json: JSON = data;

    this.id = json['id'];
    this.groupId = ogId;
    this.sceneId = sId;
    this.internalName = json['internalName'];
    this.description = json['description'];

    this.tileCaptionLineOne = json['tileCaptions']['line1'];
    this.tileCaptionLineTwo = json['tileCaptions']['line2'];
    this.thumbCaptionLineOne = json['thumbCaptions']['line1'];
    this.thumbCaptionLineTwo = json['thumbCaptions']['line2'];
    this.thumbCaptionLineThree = json['thumbCaptions']['line3'];

    if (json['carouselImages']) {
      for (const ci of json['carouselImages']) {
        this.images.push(new Image(ci['large']));
      }
    }

    if (json['ratings']) {
      this.productRatings = new ProductRatings(json['ratings'])
    }

    if (json['advert']) {
      this.ads.push(new Ad(json['advert']));
    }
  }
}

interface OptionJSON {
  id: number;
  groupId: number;
  sceneId: number;
  internalName: string;

  tileCaptionLineOne: string;
  tileCaptionLineTwo: string;
  thumbCaptionLineOne: string;
  thumbCaptionLineTwo: string;
  thumbCaptionLineThree: string;
  description: string;
  images: string;
  ads: string;
}




// WEBPACK FOOTER //
// ./src/app/model/option.ts